<template>
  <div>
    <div class="flex flex-wrap max-width mb3">
      <div
        v-for="exhibition in itemsFiltered"
        class="col-12 md-col-6 exhibition hover-toggle"
        :key="exhibition.id"
      >
        <div class="m2 sm-m3">
          <router-link
            :to="{ name: 'Exhibition', params: { slug: exhibition.slug } }"
          >
            <h2 class="exhibition-title">
              <span class="red fs-s"
                >Exh.<span v-text="exhibition.code"></span>&nbsp;</span
              >
              <span
                class="caps"
                v-html="preventWidows(exhibition.title)"
              ></span>
            </h2>
          </router-link>
          <router-link
            v-if="featured"
            :to="{ name: 'Exhibition', params: { slug: exhibition.slug } }"
          >
            <div class="exhibition-thumbnail relative">
              <img
                :data-src="getPreviewImageFile(exhibition)"
                :alt="exhibition.title"
              />
            </div>
          </router-link>

          <div class="card relative border">
            <router-link
              :to="{ name: 'Exhibition', params: { slug: exhibition.slug } }"
            >
              <div class="row card-row clearfix flex">
                <card-block
                  width="30"
                  header="Date"
                  :content="
                    exhibitionStatus(exhibition) + exhibitionDates(exhibition)
                  "
                >
                </card-block>
                <card-block
                  width="70"
                  header="Venue"
                  :content="exhibition.venue"
                >
                </card-block>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <template v-if="items.length > numFeatured">
      <div
        v-if="!showAll && !showAllExhibitions"
        @click="show"
        class="button py2 px3 mx2 sm-mx3 pointer block red"
      >
        {{ showMoreTitle }}
      </div>
    </template>
  </div>
</template>

<script>
import {
  getPreviewVideoFile,
  getPreviewImageFile,
  getPreviewImageStyle,
  exhibitionCategory,
  exhibitionDates,
  exhibitionStatus,
} from "@/utils";
import { mapState, mapActions } from "vuex";
import CardBlock from "@/components/CardBlock";

export default {
  name: "ExhibitionBlocks",

  data() {
    return {
      numFeatured: 6,
    };
  },

  components: {
    CardBlock,
  },

  props: ["type", "items", "showAll"],

  computed: {
    ...mapState(["showAllExhibitions"]),
    featured() {
      return this.type === "featured";
    },
    sortedItems() {
      const today = new Date();

      console.log("sorting", this.items);

      return [...this.items].sort((a, b) => {
        const aStart = new Date(a.start.date);
        const bStart = new Date(b.start.date);
        const aEnd = new Date(a.end.date);
        const bEnd = new Date(b.end.date);

        // Check if exhibitions are current
        const aIsCurrent = today >= aStart;
        const bIsCurrent = today >= bStart;

        if (aIsCurrent && !bIsCurrent) {
          return -1; // a comes first
        }
        if (!aIsCurrent && bIsCurrent) {
          return 1; // b comes first
        }

        // If both are current, sort by end date
        if (aIsCurrent && bIsCurrent) {
          return aEnd - bEnd;
        }

        // If neither are current, sort by start date
        return aStart - bStart;
      });
    },
    itemsFiltered() {
      if (!this.showAllExhibitions) {
        return this.sortedItems.slice(0, this.numFeatured);
      } else {
        return this.sortedItems;
      }
    },
    showMoreTitle() {
      return `Show ${this.items.length - this.numFeatured} More...`;
    },
  },

  methods: {
    ...mapActions(["showExhibitions"]),
    getPreviewVideoFile,
    getPreviewImageFile,
    getPreviewImageStyle,
    exhibitionCategory,
    exhibitionDates,
    exhibitionStatus,
    currentExhibition(exhibition) {
      if (exhibition.acf.start) {
        return (
          this.datePosition(exhibition.acf.start.date) ||
          this.datePosition(exhibition.acf.end.date)
        );
      } else {
        return false;
      }
    },
    show() {
      this.showExhibitions();
      this.$emit("updated");
    },
  },
};
</script>

<style lang="css" scoped>
#investigations {
  margin-bottom: 10em;
}
.exhibition-thumbnail {
  height: 23.75vw;
  overflow: hidden;

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.exhibition {
  h2.exhibition-title {
    width: 88%;
  }

  &:hover {
    video {
      filter: contrast(100%) grayscale(0);
    }
  }
}

.abstract {
  display: none;
  background: var(--col-light);
  left: 30%;
  width: calc(70% - var(--space-2) * 2);
  height: calc(100% - var(--space-2));
}

video {
  top: 0;
  transition: filter 0.3s ease-out;
  filter: contrast(105%) grayscale(100%);
  width: 100%;
}

.video-color {
  top: 0;
  width: 100%;
  height: 98.5%;
  background: var(--col-light);
  mix-blend-mode: multiply;
}

@media (--phone) {
  .exhibition-thumbnail {
    height: 45vw;
  }
}
</style>
